import { API } from "aws-amplify";
import { ExchangeRateDataResponse, ExchangeRateData } from "../interfaces/exchangeRate";

const API_NAMES = {
  EXCHANGE_RATE: "api-vitalicias",
};

const API_PATHS = {
  GET_EXCHANGE_RATE: "/cobranzas/tipo-cambio/consultar",
};

export const getExchangeRate = async (): Promise<ExchangeRateData> => {
  const request = {
    headers: {},
  };

  try {
    const response: ExchangeRateDataResponse = await API.get(
      API_NAMES.EXCHANGE_RATE,
      API_PATHS.GET_EXCHANGE_RATE,
      request
    );

    const exchangeRateData = response && response.payload && response.payload.responseData;
    if(!Array.isArray(exchangeRateData)|| exchangeRateData.length === 0){
      throw new Error("No exchange rate data available")
    };

    return exchangeRateData[0];
  } catch (error) {
    console.error("Error in getExchangeRate:", error);
    throw error;
  }
};
